<template>
  <w-modal v-model="open" @close="close">
    <template #header>
      <h1 class="sm:text-xl text-2xl text-center">
        變更密碼
      </h1>
    </template>
    <form>
      <w-input
        v-for="field in fields"
        v-model="$data[field.key]"
        :key="field.key"
        :label="field.label"
        :message="field.hint || getErrorMsgs(field.key)"
        :show-error="hasErrorMsgs(field.key)"
        :show-success="
          !resetPwdValidator$[field.key].invalid
          && resetPwdValidator$[field.key].$dirty
        "
        class="mb-4 w-full"
        label-class="text-black"
        password-reveal
        type="password"
        @blur="resetPwdValidator$[field.key].$touch()"
      />
    </form>
    <template #footer>
      <div class="flex justify-end">
        <w-button
          :disabled="
            updating || (resetPwdValidator$.$invalid && resetPwdValidator$.$dirty)
          "
          :loading="updating"
          :variant="resetPwdValidator$.$invalid ? 'outline' : null"
          class="sm:w-full"
          @click="updatePassword"
        >
          變更密碼
        </w-button>
      </div>
    </template>
  </w-modal>
</template>

<script>
import ResetPassword from './ResetPassword';

export default ResetPassword;
</script>

<style lang="scss" scoped>
@import 'ResetPassword';
</style>
